import ArticleLayout from '../article/components/ArticleLayout';
import { articles } from '@/mocks/articles';

export default function NajlepszeProduktyPage() {
  return <ArticleLayout article={articles[5]} />;
}